// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"511660e2","696":"52c39c44"}[chunkId] + ".chunk.css";
};